import { render, staticRenderFns } from "./time-table.vue?vue&type=template&id=8b35c808"
import script from "./time-table.vue?vue&type=script&lang=js"
export * from "./time-table.vue?vue&type=script&lang=js"
import style0 from "./time-table.vue?vue&type=style&index=0&id=8b35c808&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports